import styled from "@emotion/styled";
import { BaseButton, darkGreen, lightGreen, transparentWhite } from "@stepfinance/react";
import type { FC, MouseEvent } from "react";

import { useLanguageContext } from "../../contexts/language/language";

interface MaxHalfButtonsProps {
  showMaxButton?: boolean;
  showHalfButton?: boolean;
  balance: number;
  disabled?: boolean;
  onClick: (event: MouseEvent<HTMLElement, globalThis.MouseEvent>, clickedBalance: number) => void;
}

export const MaxHalfButtons: FC<MaxHalfButtonsProps> = ({
  onClick,
  balance,
  showHalfButton = true,
  showMaxButton = true,
  disabled,
}) => {
  const {
    currentLanguageData: { common },
  } = useLanguageContext();

  return (
    <>
      {showHalfButton && balance > 0 && (
        <>
          <StyledButton
            disabled={disabled}
            onClick={(event) => {
              onClick(event, balance / 2);
            }}
          >
            {common.halfMaxButton.half}
          </StyledButton>
        </>
      )}
      {showMaxButton && balance > 0 && (
        <>
          <StyledButton
            disabled={disabled}
            onClick={(event) => {
              onClick(event, balance);
            }}
          >
            {common.halfMaxButton.max}
          </StyledButton>
        </>
      )}
    </>
  );
};

export const BalanceSpan = styled.span<{ disabled?: boolean; selectable: boolean }>`
  display: inline;
  cursor: ${({ disabled, selectable }) => (selectable ? (disabled ? "not-allowed" : "pointer") : "default")};
  user-select: ${({ disabled }) => (disabled ? "none" : undefined)};
  color: ${transparentWhite};
  font-size: 14px;
  line-height: 22px;
`;

export const BalanceAmountText = styled.span<{ selectable?: boolean | undefined }>`
  text-decoration-line: ${({ selectable }) =>
    selectable === undefined || selectable === true ? "underline" : undefined};
  font-family: Space Mono;
`;

const StyledButton = styled(BaseButton)`
  height: 20px;
  font-size: 10px;
  padding: 0px 5px;

  :hover {
    background-color: ${darkGreen} !important;
    color: ${lightGreen};
  }

  :active {
    background-color: ${lightGreen} !important;
  }
`;
